import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { AppConfig } from '../../app.config';
import { CaseCommentModel } from '../models/caseCommentModel';
import { BaseService } from './baseService';
import { AppInsightService } from './app-insight.service';

@Injectable()
export class CommentService extends BaseService{
    constructor(protected http: HttpClient, protected config: AppConfig, protected appInsights: AppInsightService) {
        super(http, config, appInsights);
    }

    public GetCommentThreadInfos(): Promise<any> {
        var url = '/Comments/GetCommentThreadInfo';
        
        return this.httpget<any>(url);
    }

    public GetCommentThreadInfosFiltered(): Promise<any> {
        var url = '/Comments/GetCommentThreadInfoFiltered';
        return this.httpget<any>(url);
    }

    public GetCommentThread(caseId:string, ocme:string): Promise<any> {
        var url = `/Comments/GetCommentThread?caseId=${caseId}&ocme=${ocme}`;
        
        return this.httpget<any>(url);
    }

    public GetCommentThreadById(id: string, caseId: string, ocme: string): Promise<any> {
        var url = `/Comments/GetCommentThreadById?id=${id}&caseId=${caseId}&ocme=${ocme}`;
        return this.httpget<any>(url);
    }

    public AddCaseComment(ocme:string, newComment:CaseCommentModel): Promise<any> {
        var url = `/Comments/AddComment/${ocme}`;
        
        return this.httppost<any>(url, newComment);
    }

    public UpdateCaseCommentThread(thread:any): Promise<any> {
        var url = `/Comments/UpdateCommentThread`;
        return this.httppost<any>(url, thread);
    }
}